import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to calculate responsive modal width matching RecommendedForYou pattern
 * Width ranges from 360px (mobile) to 720px (desktop)
 * Formula: Math.min(720, Math.max(360, window.innerWidth - 80))
 */
export function useModalWidth() {
  const [modalWidth, setModalWidth] = useState(720);

  const updateModalWidth = useCallback(() => {
    if (typeof window === 'undefined') return;
    setModalWidth(Math.min(720, Math.max(360, window.innerWidth - 80)));
  }, []);

  useEffect(() => {
    updateModalWidth();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateModalWidth);
      return () => window.removeEventListener('resize', updateModalWidth);
    }
  }, [updateModalWidth]);

  return modalWidth;
}

export default useModalWidth;
